<br>
<!--div *ngIf="!mobiledevice" class="form-row buttontup btntop col-sm-12" style="margin-top: 10px;">
  <div class="form-group col-xs-2">
    <button class="btn border" (click)="search()" [disabled]="!meetingform.valid">Sök</button>
  </div>
  <td>
    <button class="btn border" (click)="clear()" style="margin-left:10px;">Rensa</button>
  </td>
  <td>
    <button *ngIf="can_edit_attendance" class="btn border" style="margin-left: 10px;" (click)="addMeeting()" [disabled]="!meetingform.get('institutionId').value" title="Välj institution för att aktivera knappen">Registrera möte</button>
  </td>
</div-->



<div *ngIf="!mobiledevice" class="d-flex d-justify-content-start ms-4 mt-3">
  <div class="d-flex justify-content-between gap-1">
    <button class="btn border" (click)="search()" [disabled]="!meetingform.valid">Sök</button>
     <button class="btn border" (click)="clear()">Rensa</button>
     <button *ngIf="can_edit_attendance" class="btn border" (click)="addMeeting()" [disabled]="!meetingform.get('institutionId').value" title="Välj institution för att aktivera knappen">Registrera möte</button>
  </div>
</div>
<hr class="ms-2 me-2">

<div class="d-flex justify-content-start gap-2 flex-wrap" style="margin-top:20px;margin-left:20px;">
  <div>
    <form [formGroup]="meetingform" (keydown.enter)="search()">
      <mat-expansion-panel class="accordionmargin" [expanded]="(meetingresult.length === 0 && mobiledevice) || !mobiledevice">
        <mat-expansion-panel-header [expandedHeight]="'48px'">
          <mat-panel-title>
            Möten
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="form-group">
          <label for="institution">Institution</label>
          <select class="form-control form-control-sm" id="institutionId" formControlName="institutionId" (change)="setPermissions()">
            <option></option>
            <option *ngFor="let inst of institutionlist" [value]="inst.id">{{inst.shortname}} &nbsp;{{inst.name}}</option>
          </select>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="fromDate">Datum från</label>

            <input *ngIf="mobiledevice" id="fromDate" type="text" class="form-control form-control-sm" formControlName="fromDate" mask="0000-00-00">
            <app-calendar *ngIf="!mobiledevice" [form]="meetingform" formName="fromDate"></app-calendar>&nbsp;
          </div>
          <div class="form-group col-md-6">
            <label for="toDate">Datum till</label>
            <input id="toDate" type="text" class="form-control form-control-sm" formControlName="toDate" mask="0000-00-00">
          </div>
        </div>
        <div class="form-group">
          <label for="institutionVisitingAddressCity">Ort</label>
          <input type="text" class="form-control form-control-sm" id="institutionVisitingAddressCity" formControlName="institutionVisitingAddressCity">
        </div>
        <div class="form-group">
          <label for="issue">Rubrik</label>
          <input type="text" class="form-control form-control-sm" id="issue" maxlength="30" formControlName="issue">
        </div>
        <div class="form-group">
          <label for="comment">Kommentar</label>
          <input type="text" class="form-control form-control-sm" id="comment" formControlName="comment">
        </div>
        <div class="form-group">
          <label for="meetingTypeId">
            Mötestyp
          </label>
          <select class="form-control form-control-sm" id="meetingTypeId" formControlName="meetingTypeId">
            <option></option>
            <option [ngValue]=1>Ordinarie</option>
            <option [ngValue]=2>Sommarmöte</option>
            <option [ngValue]=3>Övrigt</option>
          </select>
        </div>
      </mat-expansion-panel>
    </form>
    </div>
    <div style="overflow-x: auto;margin-left:10px;margin-top:5px;">
      <div *ngIf="meetingresult.length > 0" style="width:100%;">
        <p-menubar [model]="items" style="padding:0px;">
          <div *ngIf="mobiledevice" style="margin-left:-90px;">
            Resultat: {{meetingresult?.length}}
          </div>
          <div *ngIf="!mobiledevice" style="margin-top:5px;margin-right:10px;">
            Resultat: {{meetingresult?.length}}
          </div>
        </p-menubar>
        <table matSort (matSortChange)="sortData($event)" class="table col-md-12 border" matSortDisableClear=true>
          <thead role="rowgroup">
            <tr>
              <th mat-sort-header="meetingDate">Mötesdatum</th>
              <th mat-sort-header="issue">Rubrik</th>
              <th mat-sort-header="comment">Kommentar</th>
              <th mat-sort-header="meetingTypeName">Mötestyp</th>
              <th mat-sort-header="institutionName">Inst.</th>
              <th mat-sort-header="institutionVisitingAddressCity">Ort</th>
              <th mat-sort-header="attendants" *ngIf="meetingform.get('institutionId').value!==0 && meetingform.get('institutionId').value!==''">Närvarande</th>
              <th></th>
            </tr>
          </thead>
          <tr *ngFor="let meeting of meetingresult;">
            <td *ngIf="meeting.currentUserCanEdit"><a title="Ändra" [routerLink]="['/meetings/meetings/meetingdetails']" [queryParams]="{edit: true, id: meeting.id, institutionid: meeting.institutionId}">{{meeting.meetingDate | date: 'yyyy-MM-dd'}}</a></td>
            <td *ngIf="!meeting.currentUserCanEdit"><a title="Ändra">{{meeting.meetingDate | date: 'yyyy-MM-dd'}}</a></td>
            <td>{{meeting.issue}}</td>
            <td>{{meeting.comment}}</td>
            <td>{{meeting.meetingTypeName}}</td>
            <td><a [routerLink]="['/institutions/id/', meeting.institutionId]">{{meeting.institutionShortName}}</a></td>
            <td>{{meeting.institutionVisitingAddressCity}}</td>
            <td *ngIf="meetingform.get('institutionId').value!==0 && meetingform.get('institutionId').value!==''">{{meeting.numberOfAttendances}} (Egna: {{meeting.numberOfOwnInstitutionAttendances}}, Gäster: {{meeting.numberOfGuestAttendances}})</td>
            <td *ngIf="meeting.currentUserCanEdit"><a title="Ändra" [routerLink]="['/meetings/meetings/meetingdetails']" [queryParams]="{edit: true, id: meeting.id, institutionid: meeting.institutionId}">Ändra</a></td>
            <td *ngIf="!meeting.currentUserCanEdit"></td>
          </tr>
        </table>
      </div>
    </div>
  
</div>
<p-dialog header="Registrera möte för {{institutiondata?.shortname}} {{institutiondata?.name}}" [(visible)]="addmeetingview" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="true" [resizable]="true">
  <app-addmeeting [institution]=institutiondata (closeAddMeeting)="closeAddMeeting($event)"></app-addmeeting>
</p-dialog>
<div *ngIf="mobiledevice" class=" row buttonbottom">
  <ng-template #childTemplate>
    <div style="margin-top:10px;">
      <span class="col-md-3">
        <button class="btn border" (click)="search();">Sök</button>
      </span>
      <span class="col-md-3">
        <button class="btn border" (click)="clear()">Rensa</button>
      </span>
    </div>
  </ng-template>
  <app-footer [childTemplate]="childTemplate"></app-footer>
</div>